import { Button, Stack, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { _ } from '/@/locale';
import { logout } from '/@/store/session/actions';

const FinishDeleteAccount = () => {
    const history = useNavigate();
    const dispatch = useDispatch();
    const logoutUser = bindActionCreators(logout, dispatch);

    const finishDeleteAccount = () => {
        dispatch(logoutUser);
        history('/');
    };

    return (
        <Stack direction='column' spacing={2} alignItems='center' sx={{ p: 2 }}>
            <Typography>
                {_(
                    'Tu cuenta fue eliminada junto a todos los datos y la información que has cargado en la Plataforma. Esperamos verte de nuevo.'
                )}
            </Typography>
            <Button variant='contained' onClick={finishDeleteAccount}>
                {_('Finalizar')}
            </Button>
        </Stack>
    );
};

export default FinishDeleteAccount;
